var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8359 27.5L31.9078 12.5H27.8828L23.7297 22.193L20.7758 12.5H17.6813L14.5109 22.193L12.2742 17.7766L10.2508 23.9844L12.3055 27.5H16.2664L19.132 18.807L21.8664 27.5H25.8359ZM3.81172 22.3508H6.28438C6.95996 22.3603 7.63358 22.2759 8.28594 22.1L8.925 20.132L10.7125 14.6328C10.5745 14.4158 10.4177 14.2113 10.2437 14.0219C9.32812 13.0073 7.9862 12.5 6.21797 12.5H0V27.5H3.81172V22.3508ZM7.08516 15.9508C7.44401 16.3112 7.62318 16.7935 7.62266 17.3977C7.62214 18.0018 7.46589 18.4844 7.15391 18.8453C6.80807 19.2422 6.17161 19.4404 5.24453 19.4398H3.81172V15.4102H5.25078C6.11484 15.4102 6.7263 15.5904 7.08516 15.9508ZM29.4414 24.8133L30.5969 21.9031H33.932L32.3492 17.4883L34.3289 12.5L40 27.5H35.818L34.8492 24.8133H29.4414Z",
    fill: "#1E434D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwa);
export default __webpack_public_path__ + "static/media/pwa.aa2275354b4fcdad486e82f2bfa8fdec.svg";
export { ForwardRef as ReactComponent };